import React, { useContext, useEffect, useState } from 'react';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import TreeToppingGroup from './TreeToppingGroup';
import { PlaceStoreContext } from '../../../../../reducers/Place/PlaceContext';
import { AuthContext } from '../../../../../reducers/Auth/AuthContext';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import HeaderTag from '../../../../../lib/reusable/HeaderTag';
import QueueIcon from '@mui/icons-material/Queue';
import ReactModal from '../../../../../components/ReactModal';
import ManageToppingGroup from '../../../../../components/ManageToppingGroup';
import { COLORS } from '../../../../../utils/colors';
import config from '../../../../../utils/config';

const TreeToppings = (props) => {
  const { type } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const [authState] = useContext(AuthContext);
  const [expanded, setExpanded] = useState({});
  const {
    user: { placeId },
  } = authState;
  const [tree, setTree] = useState([]);
  const [toppingGroupModalIsOpen, setToppingGroupModalIsOpen] = useState(false);

  const {
    toppings: { toppingId__topping, toppingGroupId__toppingsGroups, indexToppings },
  } = placeState;

  const getTreeToppingGroup = (toppingGroup, initialExpanded) => {
    const toppings = [];
    const toppingsWithImages = [];
    if (indexToppings.toppingGroupId__toppings[toppingGroup.id]) {
      initialExpanded[toppingGroup.id] = false;
      const hasToppings = indexToppings.toppingGroupId__toppings[toppingGroup.id]?.length > 0;
      if (hasToppings) {
        for (const topping of indexToppings.toppingGroupId__toppings[toppingGroup.id]) {
          if (topping.has_image) {
            topping.image = `${config.uri.bucket}/${placeId}/low/${
              topping.id
            }.jpg?time=${new Date().getTime()}`;
            toppingsWithImages.push(topping.id);
          }
          toppings[topping.position - 1] = topping;
        }
      }

      toppingGroup.toppings = toppings;
    }
    return toppingGroup;
  };

  useEffect(() => {
    const newTree = [];
    const initialExpanded = {};
    initialExpanded[type] = true;
    for (const toppingGroupId in toppingGroupId__toppingsGroups) {
      const toppingGroup = toppingGroupId__toppingsGroups[toppingGroupId];
      if (toppingGroup.id === 'new') continue;

      const treeCategory = getTreeToppingGroup(toppingGroup, initialExpanded);
      newTree.push(treeCategory);
    }
    setTree(newTree.sort((a, b) => a.name.localeCompare(b.name)));
    setExpanded({ ...initialExpanded, ...expanded });
  }, [placeState]);

  const handleAddToppingGroup = (e) => {
    e.stopPropagation();
    setExpanded({ toppings: true });
    setToppingGroupModalIsOpen(true);
  };

  const handleMainLabel = () => {
    const newExpanded = { ...expanded };
    newExpanded[type] = expanded[type] ? !expanded[type] : true;
    setExpanded(newExpanded);
  };

  const MainLable = (
    <div style={{ display: 'flex', alignItems: 'center', minHeight: '56px' }}>
      <HeaderTag
        name="TOPPINGS GROUP"
        color={COLORS.S_DARK_TEXT}
        size="1rem"
        style={{ marginBottom: 0 }}
      />
      <QueueIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleAddToppingGroup} />
    </div>
  );

  const expandedArray = Object.keys(expanded).filter((key) => expanded[key] === true);

  return (
    <>
      <TreeView
        disableSelection
        defaultExpanded={[type]}
        defaultCollapseIcon={<ArrowDropDownIcon style={{ fontSize: 24 }} />}
        defaultExpandIcon={<ArrowRightIcon style={{ fontSize: 24 }} />}
        defaultEndIcon={<div style={{ width: 24 }} />}
        expanded={expandedArray}
      >
        <TreeItem nodeId={type} label={MainLable} onClick={handleMainLabel}>
          {tree.map((toppingGroup) => (
            <TreeToppingGroup
              key={toppingGroup.id}
              toppingGroup={toppingGroup}
              expanded={expanded}
              setExpanded={setExpanded}
            />
          ))}
        </TreeItem>
      </TreeView>
      {toppingGroupModalIsOpen && (
        <ReactModal modalIsOpen={toppingGroupModalIsOpen} setIsOpen={setToppingGroupModalIsOpen}>
          <ManageToppingGroup
            toppingGroupId="new"
            onClose={() => setToppingGroupModalIsOpen(false)}
          />
        </ReactModal>
      )}
    </>
  );
};

export default TreeToppings;
